// Lib
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getCurrentUser } from '../../user/currentUserSelector';
import { isFeatureEnabled, isStaff } from '../../../common/users/utils/userPropertyUtils';

const mapStateToProps = createStructuredSelector({
    isEnabled: (state, ownProps) => {
        const { featureName, staffEnabled } = ownProps;

        const user = getCurrentUser(state);
        return isFeatureEnabled(featureName, user) || (staffEnabled && isStaff(user));
    },
});

const UserFlagFeature = (props) => (props.isEnabled ? props.children : null);

UserFlagFeature.propTypes = {
    isEnabled: PropTypes.bool,
    staffEnabled: PropTypes.bool,
    featureName: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(mapStateToProps)(UserFlagFeature);
